import React from "react";
import { EditorState, convertFromRaw, CompositeDecorator } from "draft-js";
import Editor from "@draft-js-plugins/editor";

function findLinkEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges((character) => {
        const entityKey = character.getEntity();
        return (
            entityKey !== null &&
            contentState.getEntity(entityKey).getType() === "LINK"
        );
    }, callback);
}

const Link = (props) => {
    const { url } = props.contentState.getEntity(props.entityKey).getData();
    return (
        <a href={url} target="_blank" rel="noopener noreferrer">
            {props.children}
        </a>
    );
};

const decorator = new CompositeDecorator([
    {
        strategy: findLinkEntities,
        component: Link,
    },
]);

export default function Content({
    content,
    title,
}: {
    content: string;
    title: string;
}) {
    const contentState = convertFromRaw(JSON.parse(content));
    const editorState = EditorState.createWithContent(contentState, decorator);

    return (
        <section className="relative">
            <div className="max-w-screen-md mx-auto px-6 lg:px-0 mb-8 leading-loose">
                <h3 className="mb-4 font-medium text-2xl">{title}</h3>
                <div className="editor-body">
                    <Editor
                        editorState={editorState}
                        readOnly={true}
                        onChange={() => {}}
                    />
                </div>
            </div>
        </section>
    );
}
